'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _type = require('./type.js');

exports.default = {
  props: {
    listData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hasBottomBar: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: 'primary'
    },
    btnText: {
      type: String,
      default: '查看使用日志'
    }
  },
  computed: {
    matrixData: function matrixData() {
      return this.listData;
    },
    mrTextStyle: function mrTextStyle() {
      var theme = this.theme;

      var colorVal = _type.THEME_COLOR[theme] || '#00A4F2';
      return {
        color: colorVal
      };
    }
  },
  methods: {
    adaptPaddingFn: function adaptPaddingFn(li, ln, ci, cn) {
      return {};
    },
    adaptBorderFn: function adaptBorderFn(li, ln, ci, cn) {
      var hasBottomBar = this.hasBottomBar;

      if (ln === 0) {
        if (ci < cn) {
          if (hasBottomBar) {
            return _extends({
              borderRightWidth: '1px',
              borderBottomWidth: '0'
            });
          } else {
            return _extends({
              borderRightWidth: '1px',
              borderBottomWidth: '0'
            });
          }
        } else {
          if (hasBottomBar) {
            return _extends({
              borderRightWidth: '0',
              borderBottomWidth: '0'
            });
          } else {
            return _extends({
              borderRightWidth: '0',
              borderBottomWidth: '0'
            });
          }
        }
      } else {
        if (li < ln) {
          if (ci < cn) {
            return _extends({
              borderBottomWidth: '1px',
              borderRightWidth: '1px',
              paddingBottom: '40px'
            });
          } else {
            return _extends({
              borderBottomWidth: '1px',
              paddingBottom: '40px'
            });
          }
        } else {
          if (ci < cn) {
            if (hasBottomBar) {
              return _extends({
                borderRightWidth: '1px',
                borderBottomWidth: '0',
                paddingBottom: '40px'
              });
            } else {
              return _extends({
                borderRightWidth: '1px',
                borderBottomWidth: '0',
                paddingTop: '40px'
              });
            }
          } else {
            if (hasBottomBar) {
              return _extends({
                borderRightWidth: '0',
                borderBottomWidth: '0',
                paddingBottom: '40px'
              });
            } else {
              return _extends({
                borderRightWidth: '0',
                borderBottomWidth: '0',
                paddingTop: '40px'
              });
            }
          }
        }
      }
    },
    onClicked: function onClicked() {
      this.$emit('dofBottomBarClicked');
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-panel/index.vue
// module id = 364
// module chunks = 0 1